import { IoChevronBack } from "react-icons/io5";
/* eslint-disable no-unused-vars */
import { useState, useEffect } from "react";
import { Input } from "baseui/input";
import { Textarea } from "baseui/textarea";
// import {useStyletron} from 'baseui';
// import { FormControl } from "baseui/form-control";
import { Map, Marker } from '@vis.gl/react-google-maps';
import { useNavigate, useLocation } from 'react-router-dom';
// import axios from 'axios';
import { BAG_FIRST } from '../../bagFirst';
import { Post } from '../../compornents/Post';
import { toast } from 'react-toastify';
import { useModal } from 'react-hooks-use-modal';
import { TailSpin } from 'react-loading-icons'
import { Analytics, Gtag } from '../../compornents/Analytics';
import { AreaWaitlist } from '../../compornents/AreaWaitlist';
import axios from 'axios';

// 和暦表記（Profile.jsx の生年月日ブロックと同じ変換）
const wareki = (y) => {
  if (y >= 2019) return `令和${y - 2018}`;
  if (y >= 1989) return `平成${y - 1988}`;
  if (y >= 1926) return `昭和${y - 1925}`;
  if (y >= 1912) return `大正${y - 1911}`;
  return `明治${y - 1867}`;
};
// 選択できる生年（15歳以上を想定して当年-15から90年分）
const birthYears = Array.from({ length: 90 }, (_, i) => new Date().getFullYear() - 15 - i);

export const RegisterProfile = () => {
  const navigate = useNavigate();
  const [isPage, setPage] = useState(7);
  const [isOptin, setOptin] = useState(false); // クーポン等お得情報の配信同意（任意・既定OFF）
  // 生年月日（任意）。従来はプロフィール編集画面でしか登録できず、登録直後の
  // 「500円クーポンがその場でもらえる」という一番効く瞬間を取りこぼしていたため、
  // 初回登録フローにも組み込む（Profile.jsx と同じ登録API・同じ文言）。
  const [bdY, setBdY] = useState("");
  const [bdM, setBdM] = useState("");
  const [bdD, setBdD] = useState("");

  const [isName, setName] = useState("");
  const [isName2, setName2] = useState("");
  const [isFuri, setFuri] = useState("");
  const [isFuri2, setFuri2] = useState("");
  const [isZip, setZip] = useState("");
  const [isPref, setPref] = useState("");
  const [isAdd1, setAdd1] = useState("");
  const [isAdd2, setAdd2] = useState("");
  const [isAdd3, setAdd3] = useState("");
  const [isRoom, setRoom] = useState("");
  const [isSyokaiCode, setSyokaiCode] = useState("");
  const [isAddNote, setAddNote] = useState("");
  const position = { lat: 0, lng: 0 };
  const [isCenter, setCenter] = useState(position);
  const [viewToArea, setViewToArea] = useState(false);
  const [areaMsg, setAreaMsg] = useState(''); // エリア外の理由（3km超など、APIのerror_messageをそのまま表示）
  // 送信前のクライアント検証（2026-09-03）。サーバ(customer/update)と同じ条件で、
  // 足りない項目を各入力欄の直下に出す。サーバ側は最初の1件しか返さず、toastは消えるため
  // 「何が足りないか分からない」で離脱していた。条件を増やすときはAPI handlers_write.js customerUpdate と揃えること。
  const [fieldErrors, setFieldErrors] = useState({});
  const normalizeZip = (v) => String(v ?? '').replace(/[０-９]/g, (c) => String.fromCharCode(c.charCodeAt(0) - 0xfee0)).replace(/[^0-9]/g, '');
  const validateProfile = () => {
    const errs = {};
    if (!isName.trim() || !isName2.trim()) errs.name = 'お名前（漢字）を姓・名ともに入力してください';   // E007
    if (!isFuri.trim() || !isFuri2.trim()) errs.furi = 'お名前（ふりがな）を姓・名ともに入力してください'; // E008
    if (!isZip.trim()) errs.zip = '郵便番号を入力してください';                                        // E002
    else if (normalizeZip(isZip).length !== 7) errs.zip = '郵便番号は7桁の数字で入力してください';        // E009
    if (!isPref.trim()) errs.pref = '都道府県を入力してください';                                       // E010
    if (!isAdd1.trim()) errs.add1 = '市区町村を入力してください';                                       // E011
    if (!isAdd2.trim()) errs.add2 = '丁目または番地を入力してください';                                 // E012
    setFieldErrors(errs);
    const first = Object.keys(errs)[0];
    if (first) {
      Gtag('register_profile_invalid', { fields: Object.keys(errs).join(',') });
      // 最初の不足項目まで自動スクロール
      document.getElementById(`field-${first}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return !first;
  };
  const FieldError = ({ name }) => fieldErrors[name]
    ? <div className="text-danger text-left mt-1" style={{ fontSize: 12 }}>{fieldErrors[name]}</div>
    : null;

  // モーダル
  const [Modal, openModal, closeModal] = useModal('root', {
//    preventScroll: true //これはオプション。デフォルトはfalse
  });
  // 戻る
  const back = () => {
    setPage(isPage-1);
  };
  const options = {
    disableDefaultUI: true,
    zoomControl: false,
    clickableIcons: false
  };
  const geocode = () => {
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ address: isPref + isAdd1 + isAdd2 + isAdd3 }, (results, status) => {
      if (status === 'OK') {
        setCenter({ lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng() });
      }else{
        // Geocodingが失敗した場合、現在の位置を取得する
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((position) => {
            setCenter({
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            });
          }, (error) => {
            console.error("Geolocation error:", error);
          });
        } else {
          console.error("Geolocation is not supported by this browser.");
        }
      }
    });
  }

  const fetchAddress = async (zipInput) => {
    // ハイフン・全角・空白等を除去して半角数字のみに（7桁で住所検索）
    const zip = String(zipInput ?? '').replace(/[０-９]/g, (c) => String.fromCharCode(c.charCodeAt(0) - 0xfee0)).replace(/[^0-9]/g, '');
    if (zip.length === 7) {
      try {
        const response = await axios.get(
          `https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zip}`
        );
        const data = response.data;
        if (data.results) {
          const result = data.results[0];
          setPref(`${result.address1}`);
          setAdd1(`${result.address2}${result.address3}`);
        } else {
          // setAddress("住所が見つかりません");
        }
      } catch (error) {
        console.error("Error fetching address:", error);
      }
    }
  };

  const next = () => {
    if (isPage === 9) {
      setPage(0);
    } else {
      if (isPage === 7) {
        if (!validateProfile()) return;
        update_customer();
      } else if (isPage === 8) {
        update_location();
      } else {
        setPage(isPage + 1);
      }
    }
  }

  async function update_customer() {
    openModal();
    setViewToArea(false);
    const item_type = localStorage.getItem('item_type') || (BAG_FIRST ? 'pack' : 'bag');
    const request_data = {
      'first_name': isName,
      'last_name': isName2,
      'first_furigana': isFuri,
      'last_furigana': isFuri2,
      'zip': isZip,
      'pref': isPref,
      'add1': isAdd1,
      'add2': isAdd2,
      'add3': isAdd3,
      'room': isRoom,
      'add_note': isAddNote,
      'syokai_code': isSyokaiCode,
      'item_type': item_type,
      // 流入元(ロッカーQR等の ?ref=)。API側で customers.know に保存する（初回のみ）。
      'ref': localStorage.getItem('lp_ref') || '',
    }
    // post
    const response_data = await Post('post', '/customer/update.php', request_data);
    if (response_data.result === 1) {
      // 配信同意（任意チェック）を保存。失敗しても登録は継続。
      if (isOptin) {
        Post('post', '/customer/set_flag.php', { type: 'is_marketing_optin', value: 1 }).catch(() => {});
      }
      // 生年月日（任意入力）。3つとも選ばれているときだけ登録する。
      // 失敗しても登録フローは止めない（あとからプロフィール画面で登録できる）。
      if (BAG_FIRST && bdY && bdM && bdD) {
        const bd = `${bdY}-${String(bdM).padStart(2, '0')}-${String(bdD).padStart(2, '0')}`;
        Post('post', '/customer/birthday.php', { birthday: bd })
          .then((r) => { if (r?.coupon) toast.success(`${Number(r.coupon.kingaku).toLocaleString()}円クーポンをプレゼント🎁`); })
          .catch(() => {});
      }
      geocode();
      // 顧客登録成功
      Gtag('register_customer_success');
      Gtag('view_register_location');
      setPage(8);
      if(response_data.has_item===0){
        toast.error("申し訳ございません。お客様の住所ではふとんサービスを行なっておりません");
      }
    } else {
      // エラー
      toast.error(response_data.error_message);
      if(response_data.error_code==='E003'){
        // エリア対象外
        setViewToArea(true);
        Gtag('out_of_service_area');
      }
      // 顧客登録失敗
      Gtag('register_customer_failed', {
        error_message: response_data.error_message,
      });
    }
    closeModal();
  }

  async function update_location() {
    openModal();
    setViewToArea(false);
    const request_data = {
      'lat': isCenter.lat,
      'lon': isCenter.lng,
    }
    // post
    const response_data = await Post('post', '/customer/update_location.php', request_data);
    const customer = response_data.customer;
    if (response_data.result === 1) {
      // サインアップコンバージョン
      Gtag('conversion_event_signup');
      const request_data2 = {};
      const response_data2 = await Post('post', '/order/item.php', request_data2);
      if (response_data2.result === 1) {
        const items = response_data2.items;
        const item_type = localStorage.getItem('item_type') || (BAG_FIRST ? 'pack' : 'bag');
        // console.log(item_type);
        const foundItem = items.find(item => item.type === item_type);
        // console.log(foundItem);
        if(foundItem){
          // 見積もり取得
        // console.log(foundItem);
          const request_data3 = {item_id: foundItem['id'],lpspot_id:foundItem['lpspot']['id']}
          const response_data3 = await Post('post', '/order/quote.php', request_data3);
          if (response_data3.result === 1) {
            const quote = response_data3.quote;
            navigate("/confirm", { state: { data:{item: foundItem, quote: quote,customer:customer,user_dropoff_type:'uber' }} });
          } else {
            // エラー
            toast.error(response_data3.error_message);
            if(response_data.error_code==='E021'){
              // 11秒後にホームへ
              setTimeout(() => {
                navigate("/home");
              }, 11000);
            }
            if(response_data3.error_code==='E003'){
              setViewToArea(true);
            }
          }
        }else{
          // 選択した商品がないのでホームへ
          navigate("/home");
        }
      } else {
        // エラー
        toast.error(response_data2.error_message);
      }
    } else {
      Gtag('register_location_failed', {
        error_message: response_data.error_message,
      });
      toast.error(response_data.error_message);
      if(response_data.error_code==='E003'){
        setViewToArea(true);
        setAreaMsg(response_data.error_message || '');
      }
    }
    closeModal();
  }

  useEffect(() => {
    const syokai_code = localStorage.getItem("syokai_code");
    if (syokai_code) {
        setSyokaiCode(syokai_code);
    }
    Gtag('view_register_profile');
  }, []);

  if (isPage === 8) {
    return (
      <div>
        <div>
            <Analytics title="ピンの位置の調整" />
            <div className="Register m-auto">
              <div className="App">
                <div className="toolbar mb-3">
                  <div className="toolbar_left div_btn" onClick={back} >
                    <IoChevronBack />
                  </div>
                  <div className="toolbar_center">
                    ピンの位置を調整<span className="text-danger">(重要)</span>
                  </div>
                  <div className="toolbar_right">
                  </div>
                </div>
                <div className="Add-comment">{isAdd2}</div>
                <div className="App-map">
                  <Map
                    center={isCenter}
                    zoom={18}
                    onCenterChanged={e => {
                      setCenter({ lat: e.detail.center.lat, lng: e.detail.center.lng });
                    }}
                    options={options}
                  >
                    <Marker position={isCenter} />
                  </Map>
                </div>
                <div className="Map-comment">{"Uber配達員が速やかにお伺いできるよう、ピンでお届け先の正しい位置を示してください"}</div>

                {/* エリア外(E003): 郵便番号画面と同じ自前フォーム(area_waitlist)へ統一。zipを引き継ぐ（2026-09-03） */}
                {viewToArea===true && (
                  <div className="m-3">
                    <div className="text-danger mb-2" style={{ fontSize: 13 }}>
                      {areaMsg || '申し訳ございません。ご利用エリア外の住所です。'}
                    </div>
                    <AreaWaitlist postcode={isZip} />
                  </div>
                )}
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '20px',
                }}>
                  <button className="button-next" onClick={next}>{"住所を保存"}</button>
                </div>
              </div>
            </div>
            <Modal>
              <div className="modal rounded text-center pb-4 pl-4 pr-4 m-1">
                <button onClick={closeModal} className="hide">閉じる</button>
                <div >
                  <TailSpin stroke="#000" />
                </div>
                <div className="">
                  <div className="">
                    処理中です
                  </div>
                </div>
              </div>
            </Modal>
        </div>
      </div>
    );
  }
  return (
    <div>
      <div>
        <Analytics title="個人情報入力" />
          <div className="Register m-auto">
            <div className="App-inline mb-5 pb-5">
              <div className="App-subtitle">{"個人情報入力"}</div>
              <div className="Input-view" id="field-name">
                <div className="Input-title">{"お名前（漢字）"} <span className="Input-require">{"*"}</span>
                  <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: '20px',
                    paddingTop: '10px',
                  }}>
                    <Input
                      value={isName}
                      onChange={e => setName(e.target.value)}
                      placeholder="例）山田"
                      clearOnEscape
                    />
                    <Input
                      value={isName2}
                      onChange={e => setName2(e.target.value)}
                      placeholder="花子"
                      clearOnEscape
                    />
                  </div>
                  <FieldError name="name" />
                </div>
              </div>
              <div className="Input-view" id="field-furi">
                <div className="Input-title">{"お名前（ふりがな）"} <span className="Input-require">{"*"}</span>
                  <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: '20px',
                    paddingTop: '10px',
                  }}>
                    <Input
                      value={isFuri}
                      onChange={e => setFuri(e.target.value)}
                      placeholder="例）やまだ"
                      clearOnEscape
                    />
                    <Input
                      value={isFuri2}
                      onChange={e => setFuri2(e.target.value)}
                      placeholder="はなこ"
                      clearOnEscape
                    />
                  </div>
                  <FieldError name="furi" />
                </div>
              </div>
              <div className="Input-view" id="field-zip">
                <div className="Input-title">{"郵便番号"} <span className="Input-require">{"*"}</span>
                  <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: '20px',
                    paddingTop: '10px',
                  }}>
                    <Input
                      value={isZip}
                      onChange={e => {
                        fetchAddress(e.target.value);
                        setZip(e.target.value);}}
                      placeholder="例:8001234"
                      clearOnEscape
                    />
                  </div>
                  <FieldError name="zip" />
                </div>
              </div>
              <div className="Input-view" id="field-pref">
                <div className="Input-title">{"都道府県"} <span className="Input-require">{"*"}</span>
                  <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: '20px',
                    paddingTop: '10px',
                  }}>
                    <Input
                      value={isPref}
                      onChange={e => setPref(e.target.value)}
                      placeholder="例:東京都"
                      clearOnEscape
                    />
                  </div>
                  <FieldError name="pref" />
                </div>
              </div>
              <div className="Input-view" id="field-add1">
                <div className="Input-title">{"市区町村"} <span className="Input-require">{"*"}</span>
                  <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: '20px',
                    paddingTop: '10px',
                  }}>
                    <Input
                      value={isAdd1}
                      onChange={e => setAdd1(e.target.value)}
                      placeholder="例:港区六本木"
                      clearOnEscape
                    />
                  </div>
                  <FieldError name="add1" />
                </div>
              </div>
              <div className="Input-view" id="field-add2">
                <div className="Input-title">{"丁目または番地"} <span className="Input-require">{"*"}</span>
                  <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: '20px',
                    paddingTop: '10px',
                  }}>
                    <Input
                      value={isAdd2}
                      onChange={e => setAdd2(e.target.value)}
                      placeholder="例:1-1-1"
                      clearOnEscape
                    />
                  </div>
                  <FieldError name="add2" />
                </div>
              </div>
              <div className="Input-view">
                <div className="Input-title">{"建物名"}
                  <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: '20px',
                    paddingTop: '10px',
                  }}>
                    <Input
                      value={isAdd3}
                      onChange={e => setAdd3(e.target.value)}
                      placeholder="例:ランドリーマンション"
                      clearOnEscape
                    />
                  </div>
                </div>
              </div>
              <div className="Input-view">
                <div className="Input-title">{"部屋番号"}
                  <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: '20px',
                    paddingTop: '10px',
                  }}>
                    <Input
                      value={isRoom}
                      onChange={e => setRoom(e.target.value)}
                      placeholder="例:101"
                      clearOnEscape
                    />
                  </div>
                </div>
              </div>
              <div className="Input-view">
                <div className="Input-title">{"住所の詳細"}
                  <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: '20px',
                    paddingTop: '10px',
                  }}>
                    <Textarea
                      value={isAddNote}
                      onChange={e => setAddNote(e.target.value)}
                      placeholder="例:一戸建、表札あり、建物の外観"
                      maxLength={100}
                      clearOnEscape
                    />
                  </div>
                </div>
              </div>
              <div className="Input-view">
                <div className="Input-title">{"お友達紹介・クーポンコード"}
                  <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: '20px',
                    paddingTop: '10px',
                  }}>
                    <Input
                      value={isSyokaiCode}
                      onChange={e => setSyokaiCode(e.target.value)}
                      placeholder="例:ABCD1234"
                      clearOnEscape
                    />
                  </div>
                </div>
              </div>
              {/* エリア外(E003): 郵便番号画面と同じ自前フォーム(area_waitlist)へ統一。zipを引き継ぐ（2026-09-03） */}
              {viewToArea===true && (
                <div className="m-3">
                  <div className="text-danger mb-2" style={{ fontSize: 13 }}>
                    申し訳ございません。ご利用エリア外の住所です。
                  </div>
                  <AreaWaitlist postcode={isZip} />
                </div>
              )}
              {/* 生年月日（任意）。Profile.jsx の登録ブロックと同じ構成・同じAPI。
                  bag-first の承認済みモックで初回登録フローに組み込まれた項目のため同じフラグで出し分ける。 */}
              {BAG_FIRST && (
              <div className="Input-view">
                <div className="Input-title">{"生年月日"}
                  <div className="text-left" style={{ background: '#fff0f4', border: '1px solid #f5c2d0', borderRadius: 10, padding: '10px 12px', fontSize: 13, lineHeight: 1.7, marginTop: 10 }}>
                    🎂 ご登録で<b>500円クーポン</b>をその場でプレゼント！お誕生月には毎年<b>1,000円クーポン</b>をお届けします
                  </div>
                  <div className="row" style={{ paddingTop: '10px' }}>
                    <div className="col-5">
                      <select className="form-control" value={bdY} onChange={(e) => setBdY(e.target.value)}>
                        <option value="">年</option>
                        {birthYears.map((y) => (
                          <option key={y} value={y}>{y}年（{wareki(y)}）</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-3">
                      <select className="form-control" value={bdM} onChange={(e) => setBdM(e.target.value)}>
                        <option value="">月</option>
                        {Array.from({ length: 12 }, (_, i) => i + 1).map((m) => (
                          <option key={m} value={m}>{m}月</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-4">
                      <select className="form-control" value={bdD} onChange={(e) => setBdD(e.target.value)}>
                        <option value="">日</option>
                        {Array.from({ length: 31 }, (_, i) => i + 1).map((d) => (
                          <option key={d} value={d}>{d}日</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="text-gray-dark" style={{ fontSize: 12, marginTop: 8 }}>
                    ※生年月日のみ、登録後の変更はできません（他の項目はあとから変更できます）
                  </div>
                </div>
              </div>
              )}
              <div className="m-3 text-left" style={{ background: '#fffbe6', border: '1px solid #ffe082', borderRadius: 10, padding: '10px 12px' }}>
                <label style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginBottom: 0, cursor: 'pointer' }}>
                  <input type="checkbox" checked={isOptin} onChange={(e) => setOptin(e.target.checked)} style={{ marginTop: 3 }} />
                  <span style={{ fontSize: 13 }}>🎁 クーポン・キャンペーン等のお得情報の配信を受け取る（任意・いつでも設定から停止できます）</span>
                </label>
              </div>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '20px',
              }}>
                <button className="button-next" onClick={next}>{"次へ"}</button>
              </div>
            </div>
          </div>
          <Modal>
            <div className="modal rounded text-center pb-4 pl-4 pr-4 m-1">
              <button onClick={closeModal} className="hide">閉じる</button>
              <div >
                <TailSpin stroke="#000" />
              </div>
              <div className="">
                <div className="">
                  処理中です
                </div>
              </div>
            </div>
          </Modal>
      </div>
    </div>
  );
}
